var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Widget = (function (Widget) {

        Widget.Messages = (function (Messages) {

        Messages.BindControl = function (context) {
            var data = {
                context: context
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Widget.Messages.BindControl', data);
        };
        Messages.BindControl.className = 'Vendd.Widget.Messages.BindControl';

        Messages.OpenWidget = function (widgetName, immediate) {
            var data = {
                widgetName: widgetName,
                immediate: immediate
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Widget.Messages.OpenWidget", data);
        };
        Messages.OpenWidget.className = "Vendd.Widget.Messages.OpenWidget";

        Messages.WidgetOpened = function (widgetName) {
            var data = {
                widgetName: widgetName
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Widget.Messages.WidgetOpened", data);
        };
        Messages.WidgetOpened.className = "Vendd.Widget.Messages.WidgetOpened";

        return Messages;

    })(Widget.Messages || {});

        return Widget;

    })(Vendd.Widget || {});

return Vendd;

})(Vendd || {});